import { render, staticRenderFns } from "./defaultRecommendList.vue?vue&type=template&id=677a5206&scoped=true&"
import script from "./defaultRecommendList.vue?vue&type=script&lang=js&"
export * from "./defaultRecommendList.vue?vue&type=script&lang=js&"
import style0 from "./defaultRecommendList.vue?vue&type=style&index=0&id=677a5206&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a5206",
  null
  
)

export default component.exports